(function () {
    'use strict';

    angular
        .module('app')
        .controller('ListConcertsController', ListConcertsController);

    ListConcertsController.$inject = ['$http', '$state', '$scope', 'eventTracker'];

    function ListConcertsController($http, $state, $scope, eventTracker) {
        var vm = this;
        vm.state = $state;
        vm.productClick = productClick;

        vm.$onChanges = function () {
            if (vm.concerts) {
                vm.concerts.forEach(concert => {
                    concert.isLastYear = moment(concert.concert_start_time).isBefore(moment(), 'years');
                    concert.position = vm.concerts.map(function(o) { return o.concert_slug; }).indexOf(concert.concert_slug)+1;
                    if(vm.pageNumber){
                        concert.position *= vm.pageNumber;
                    }
                });
            }
        }

        function productClick(concert){
            if (vm.sourcePage == "list_concerts"){
                eventTracker.productClick(concert, "Concerts Page Concert List")
            }
            if (vm.sourcePage == "frontpage"){
                eventTracker.productClick(concert, "Frontpage Concert List")
            }
            if (vm.sourcePage == "musician_profile"){
                eventTracker.productClick(concert, "Musician Profile Concert List")
            }
            if (vm.sourcePage == "host_profile"){
                eventTracker.productClick(concert, "Host Profile Concert List")
            } 
        }

    }
})();

